module.exports = __webpack_public_path__ + "images/home/masters/logo@2x-b971a3a5aa7e41897b6e50c5c779481b.png";